var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconComputer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 2,
    y: 3,
    width: 20,
    height: 11,
    fill: "#FCFCFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.61183 17.6687H9.13857L8.90681 19.2131H8.0154C7.52512 19.2131 7.12399 19.6262 7.12399 20.1111C7.12399 20.587 7.52512 21 8.0154 21H15.9757C16.4749 21 16.8671 20.587 16.8671 20.1111C16.8671 19.6262 16.4749 19.2131 15.9757 19.2131H15.0843L14.8614 17.6687H20.3793C22.0818 17.6687 23 16.7798 23 15.0378V4.63091C23 2.88894 22.0818 2 20.3793 2H3.61183C1.90924 2 1 2.88894 1 4.63091V15.0378C1 16.7798 1.90924 17.6687 3.61183 17.6687ZM3.33549 13.3318C3.0859 13.3318 2.97002 13.233 2.97002 12.9636V4.81049C2.97002 4.20888 3.22853 3.97543 3.79011 3.97543H20.201C20.7715 3.97543 21.03 4.20888 21.03 4.81049V12.9636C21.03 13.233 20.9141 13.3318 20.6645 13.3318H3.33549ZM12 16.7528C11.4919 16.7528 11.0818 16.3398 11.0818 15.837C11.0818 15.3341 11.4919 14.9121 12 14.9121C12.4992 14.9121 12.9092 15.3341 12.9092 15.837C12.9092 16.3398 12.4992 16.7528 12 16.7528Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComputer);
export default __webpack_public_path__ + "static/media/icon-computer.c29146a22dab0e1fbeddb2a13db67577.svg";
export { ForwardRef as ReactComponent };